import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/find";
import React, { useEffect } from 'react';
import arrayMutators from 'final-form-arrays';
import { noop, isEqual } from 'lodash';
import PropTypes from 'prop-types';
import { Form, Field } from 'react-final-form';
import { FieldArray } from 'react-final-form-arrays';
import { validations } from '@unite-us/client-utils';
import { PaymentsSupportingDocuments } from './PaymentsSupportingDocuments';
export var EnrollmentsSupportingDocuments = function EnrollmentsSupportingDocuments(_ref) {
  var _metaFieldFiles$map;
  var onSubmit = _ref.onSubmit,
    metaFieldFiles = _ref.metaFieldFiles,
    submitTriggered = _ref.submitTriggered;
  var initialMetadata = (_metaFieldFiles$map = metaFieldFiles === null || metaFieldFiles === void 0 ? void 0 : _mapInstanceProperty(metaFieldFiles).call(metaFieldFiles, function (_ref2) {
    var field = _ref2.field;
    return {
      field: field
    };
  })) !== null && _metaFieldFiles$map !== void 0 ? _metaFieldFiles$map : [];
  return /*#__PURE__*/React.createElement(Form, {
    onSubmit: onSubmit,
    mutators: _objectSpread({}, arrayMutators),
    initialValues: {
      metadata: initialMetadata
    },
    initialValuesEqual: function initialValuesEqual(oldFields, newFields) {
      var _context, _context2;
      return isEqual(_mapInstanceProperty(_context = oldFields.metadata).call(_context, function (_ref3) {
        var field = _ref3.field;
        return {
          field: field
        };
      }), _mapInstanceProperty(_context2 = newFields.metadata).call(_context2, function (_ref4) {
        var field = _ref4.field;
        return {
          field: field
        };
      }));
    }
  }, function (_ref5) {
    var handleSubmit = _ref5.handleSubmit;
    useEffect(function () {
      if (submitTriggered) {
        handleSubmit();
      }
    }, [submitTriggered]);
    return /*#__PURE__*/React.createElement("form", {
      id: "supporting-documents-form"
    }, /*#__PURE__*/React.createElement(FieldArray, {
      name: "metadata"
    }, function (_ref6) {
      var fields = _ref6.fields;
      return _mapInstanceProperty(fields).call(fields, function (name, index) {
        var _metaFieldFile$valida;
        var metaFieldFile = _findInstanceProperty(metaFieldFiles).call(metaFieldFiles, function (file) {
          return fields.value[index].field === file.field;
        });
        if (!metaFieldFile) return null;
        var fieldName = metaFieldFile === null || metaFieldFile === void 0 ? void 0 : metaFieldFile.field;
        var isRequired = !!(metaFieldFile !== null && metaFieldFile !== void 0 && (_metaFieldFile$valida = metaFieldFile.validations) !== null && _metaFieldFile$valida !== void 0 && _metaFieldFile$valida.required);
        return /*#__PURE__*/React.createElement("div", {
          className: "payments-supporting-documents-wrapper pb-6",
          key: fieldName
        }, /*#__PURE__*/React.createElement(Field, {
          name: "".concat(name, ".value"),
          validate: isRequired ? validations.isRequired : noop
        }, function (_ref7) {
          var input = _ref7.input,
            meta = _ref7.meta;
          return /*#__PURE__*/React.createElement(PaymentsSupportingDocuments, {
            label: metaFieldFile === null || metaFieldFile === void 0 ? void 0 : metaFieldFile.label,
            fieldName: fieldName,
            field: input,
            required: isRequired,
            invalid: meta.invalid,
            touched: meta.touched
          });
        }));
      });
    }));
  });
};
EnrollmentsSupportingDocuments.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  submitTriggered: PropTypes.number.isRequired,
  metaFieldFiles: PropTypes.array.isRequired
};
//# sourceMappingURL=EnrollmentsSupportingDocuments.js.map